var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-box"},[_c('div',{staticClass:"header"},[_c('img',{staticClass:"md:w-[221px] w-[130px] aspect-[5/2]",attrs:{"src":"/images/jtca_logo_horizontal.png","alt":"JTCA"}})])])
}]

export { render, staticRenderFns }